import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotComics from './components/HotComics';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import WeeklyRanking from './components/WeeklyRanking';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <HotComics />
        <LatestUpdates />
        <WeeklyRanking />
      </main>
      <Footer />
    </>
  );
}